// extracted by mini-css-extract-plugin
module.exports = {"table":"RmTableRow_table__1hFI7","name":"RmTableRow_name__1HJ7F","table-row":"RmTableRow_table-row__3qbv4"};